import { createSlice } from "utils/@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { ContainerState, CreateAssetResponse, ICreatePayload } from "../types";

// The initial state of the GithubRepoForm container
export const initialState: ContainerState = {
  url: null,
  isLoading: false,
  progress: 0,
};

const MediaUploadSlice = createSlice({
  name: "mediaUploadState",
  initialState,
  reducers: {
    resetMediaUploadSlice() {
      return initialState;
    },
    uploadMedia(
      state,
      action: PayloadAction<{
        media: ICreatePayload;
        callback: (data: CreateAssetResponse) => void;
      }>,
    ) {
      state.isLoading = true;
      state.progress = 0;
    },
    uploadMediaSuccess(state, action: PayloadAction<string>) {
      state.url = action.payload;
      state.isLoading = false;
      state.progress = 0;
    },
    uploadMediaError(state) {
      state.isLoading = false;
      state.progress = 0;
    },
    cancelUpload(state) {
      state.isLoading = false;
      state.progress = 0;
    },
    uploadProgress(state, action: PayloadAction<number>) {
      state.progress = action.payload;
    },
  },
});

export const {
  actions,
  reducer: mediaUploadReducer,
  name: mediaUploadSlice,
} = MediaUploadSlice;
